import { useNavigate } from 'react-router-dom';
import { PatientsTab } from '../pages/psychologist/tabs';

/**
 * Pacientes en la app mobile: el MISMO módulo de la web (lista con filtros por estado, buscador, ficha del paciente y sus
 * acciones). Lo único propio es a dónde lleva "Agendar": la Agenda de la app es `/` (la web usa `/calendar?process=`).
 * Lo que no corresponde en mobile (tour de onboarding, exportar CSV, links a Gmail web) se oculta adentro con `useIsPwaApp()`.
 */
export function PwaPacientes() {
  const navigate = useNavigate();
  return <PatientsTab onSchedule={(processId: string) => navigate(`/?process=${encodeURIComponent(processId)}`)} />;
}
